export const apiKey = "AIzaSyBbD02bxWD9Z-gS8de9rxcEeSu4ZupI5hc";
export const authDomain = "smallbusinessforward-638f1.firebaseapp.com";
export const projectId = "smallbusinessforward-638f1";
export const storageBucket = "smallbusinessforward-638f1.appspot.com";
export const messagingSenderId = "352284940617";
export const appId = "1:352284940617:web:b3d8d0dccf3d607d792298";
export const measurementId = "G-NN28MQH2ZE";
